<template>
  <v-container fluid grid-list-xl>
    <v-layout align-content-center justify-center column wrap>
      <v-flex xs6 md6 class="text-xs-center">
        <v-avatar size="80">
          <v-img avatar src />
        </v-avatar>
      </v-flex>
      <v-flex xs6 md6>
        <v-card :title="appName" :text="('Login.loginTitle')" class="text-md-center">
          <v-form ref="form" v-model="valid" @keyup.native.enter="loginUser">
            <v-container py-0>
              <v-layout wrap>
                <v-flex xs12 md12>
                  <v-text-field
                    :label="('Email')"
                    v-model="userEmail"
                    type="email"
                    :counter="100"
                    :rules="[
                      v => !!v || ('Password'),
                      v => v.length >= 2 || ('Login.userEmailMoreThen'),
                    ]"
                    prepend-icon="mdi-account"
                    class="info-input font-weight-bold"
                  />

                  <v-text-field
                    :label="('Password')"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPassword ? 'text' : 'password'"
                    v-model="userPassword"
                    :counter="18"
                    :rules="[
                      v => !!v || ('Login.passwordRequired'),
                      v => v.length >= 3 || ('Login.passwordMoreThen'),
                      v => v.length <= 18 || ('Login.passwordLessThen'),
                    ]"
                    prepend-icon="mdi-lock"
                    class="info-input font-weight-bold"
                    @click:append="showPassword = !showPassword"
                  />
                  <v-autocomplete
                    prepend-icon="mdi-collage"
                    @change="setDashboard"
                    v-model="selectedDashboardName"
                    :items="dashboards"
                    item-text="name"
                    label="Campaign Dashboard"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 text-xs-right>
                  <v-btn
                    class="mx-0 font-weight-light"
                    color="success"
                    @click="loginUser"
                  >{{ ('Login') }}</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";

export default {
  data: () => ({
    appName: process.env.VUE_APP_NAME,
    valid: true,
    showPassword: false,
    userEmail: "",
    userPassword: "",
    dashboards: [],
    selectedDashboardName: null
  }),
  mounted() {
    this.getCampaignDashboards().then(res => {
      this.dashboards = res;
      console.log("DSAFDFADSGFADASF", res);
    });
  },
  computed: {
    ...mapGetters(["selectedDashboard", "userToken"])
  },
  methods: {
    ...mapActions(["login", "getCampaignDashboards","getDashboardData"]),
    setDashboard(val) {
      const selectedDashboard = this.dashboards.find(
        dashboard => dashboard.name === val
      );
      this.$store.commit('setDashboard', selectedDashboard);

    },
    loginUser() {
      if (this.$refs.form.validate()) {
        let user = {
          email: this.userEmail,
          password: this.userPassword
        };
        const dashboard = this.selectedDashboard;
        this.login({ user, dashboard }).then(resp => {
          if (resp) {
            console.log("LOGIN",resp)
            if (resp.level === "OPERATOR" || resp.level==='ADMIN') this.$router.push("/receipts");
            if (resp.level === "AGENT") this.$router.push("/agent");
            if (resp.level === "SERVICEOP") this.$router.push('/serviceOp')
            if (resp.level === "AGENTL1") this.$router.push('/agentL1')
          }
        });
      }
    }
  }
};
</script>
